import axios from 'axios';

const sendSupraSystemSubscriptionInvitation = async (body: {
  userId: string;
  orgId: string;
}) => {
  await axios.post('/supra_system/subscription/send_invite', body);
};

const userFriendlyErrorMessages = [
  /User has already activated their subscription/,
];

export const isUserFriendlyError = (message?: string) => {
  if (!message) return false;

  return userFriendlyErrorMessages.reduce(
    (prev, re) => prev || re.test(message),
    false,
  );
};

export default sendSupraSystemSubscriptionInvitation;
